import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_GREY,
    codeProp: 'chgNo',
    detailUrl: '/ChgDetail',
    detailIdProp: 'chgId',
    mapProp: 'chgMap',
    name: '系统变更单',
    textProp: 'chgTitle',
    type: 'CHG',
}
